/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).ready(function() {  

  $("form .review-order-btn").on("click", function(event) { 
    if (purchaseOrderIsBeingEdited()) {
      event.preventDefault();
      return $("#pending-line-items-in-cart-modal").modal({show: true});
    }
  });

  $("form#order_type_selector input:radio").on("change", function(event) {
    return $(this).parents('form').submit();
  });

  $("a.alternative-toggle").on("click", function() {
    const target = $($(this).data("substitute-id"));
    target.toggleClass("hidden");
    if (target.hasClass("hidden")) {
      return $(this).prev("span").removeClass("glyphicon-chevron-down").addClass("glyphicon-chevron-right");
    } else {
      return $(this).prev("span").addClass("glyphicon-chevron-down").removeClass("glyphicon-chevron-right");
    }
  });


  $(".delivery_method-group input:radio").on("change", function(event) {
    const target = $(".accept_delivery_time_not_guaranteed-group");
    if ($(this).val() === "M") { 
      return target.removeClass('hidden');
    } else {
      return target.addClass('hidden');
    }
  });
 
  $(".delivery_method-group input:radio").on("change", function(event) {
    const target = $(".accept_delivery_surcharge-group");
    if (($(this).val() === "E") && ($('[data-weight]').attr("data-weight") > 30)) {
      target.removeClass('hidden');
    } else {
      target.addClass('hidden');
    }
    
    const shipping_notice = $(".shipping_notice-group");
    if ($(this).val() === "E") {
      return shipping_notice.removeClass('hidden');
    } else {
      return shipping_notice.addClass('hidden');
    }
  });      

  $(".edit_comment_link").popover({
    animate: true,
    html: true,
    placement: "bottom",
    content() {
      const source = $(this).attr("href");

      const response = $.ajax({
        url: source,
        async: false
      });

      return response.responseText;
    }
  });

  $(".edit_comment_link").on("click", event => event.preventDefault());

  $(".edit_quantity_link").popover({
    animate: true,
    html: true,
    placement: "bottom",
    container: "body",
    content() {
      const source = $(this).attr("href");
      const response = $.ajax({
        url: source,
        async: false
      });

      return response.responseText;
    }
  });

  $(".edit_quantity_link").on("click", event => event.preventDefault());

  $(".display_search_history_btn").popover({
    animate: true,
    html: true,
    placement: "bottom",
    container: "body",
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h2 class="popover-title"></h2><div class="popover-content"></div></div>'
  });
  $(".display_search_history_btn").on("click", event => event.preventDefault());
    
  $("form.purchase_order_review_form select#purchase_order_order_type").on("change", function(event) {
    const postData = { 
      purchase_order: { 
        order_type: $(this).val()
      },
      authenticity_token: document.head.querySelector(`meta[name="csrf-token"]`).getAttribute('content')
    };
    const ajaxConfig = {
      type: "PUT",
      dataType: "json",
      data: postData,
      url: $(this).data("update-on-change"),
      success(data) { 
        if (data.location) {
          return window.location.replace(data.location);
        }
      }
    };
          
    return $.ajax(ajaxConfig);
  });

  $(".item.btn-stepper").on("click", function(event) {
    event.preventDefault();

    if (purchaseOrderIsBeingEdited()) { return; }

    const availabilityAddon = $($(this).data("target")+" .availability_addon");
    const quantityField = $($(this).data("target")+" .edit_quantity_link");
    const lineTotalField = $($(this).data("target")+" .line_item_total_amount");
    const discountField = $($(this).data("target")+" .line_item_discount");
    const netPriceField = $($(this).data("target")+" .line_item_net_price");
    const basePriceField = $($(this).data("target")+" .line_item_base_price");
    const orderTotalField = $("#purchase_order_total_amount");

    const originalQuantity = quantityField.html();

    quantityField.html("<i class='fa-solid fa-circle-notch fa-spin' aria-hidden='true'></i>");

    const ajaxConfig = {
      type: "POST",
      dataType: "json",
      url: $(this).data("url"),
      success(data, textStatus) {
        if (textStatus==="notmodified") {
          quantityField.html(originalQuantity);
          return;
        }

        availabilityAddon.replaceWith(data.purchase_order_item.availability_addon);
        quantityField.html(data.purchase_order_item.quantity);
        lineTotalField.html(data.purchase_order_item.total_amount);
        orderTotalField.html(data.purchase_order.total_amount);
        discountField.html(data.purchase_order_item.discount_1);
        netPriceField.html(data.purchase_order_item.net_price);
        return basePriceField.html(data.purchase_order_item.base_price);
      }
    };

    return $.ajax(ajaxConfig);
  });

  return $(document).on("click", "#blank_line_item_row .btn-stepper", function(event) {
    event.preventDefault();

    const element = $(event.target);
    const url = element.data("url");

    const availabilityAddon = $(element.data("target")+" .availability_addon");
    const quantityField = $("#purchase_order_item_quantity");
    const lineTotalField = $(element.data("target")+" .line_item_total_amount");
    const discountField = $(element.data("target")+" .line_item_discount");
    const netPriceField = $(element.data("target")+" .line_item_net_price");
    const basePriceField = $(element.data("target")+" .line_item_base_price");
    const orderTotalField = $("#purchase_order_total_amount");

    //originalQuantity = quantityField.html()

    //quantityField.html("<i class='fa-solid fa-circle-notch fa-spin' aria-hidden='true'></i>")

    const ajaxConfig = {
      type: "POST",
      dataType: "json",
      url,
      data: { 
        purchase_order_item: { 
          quantity: quantityField.val(),
          product_id: element.data("product-id")
        }
      },
      success(data, textStatus) {
        if (textStatus==="notmodified") {
          return;
        }

        availabilityAddon.replaceWith(data.purchase_order_item.availability_addon);
        
        quantityField.val(data.purchase_order_item.quantity);
        
        lineTotalField.html(data.purchase_order_item.total_amount);
        orderTotalField.html(data.purchase_order.total_amount);
        discountField.html(data.purchase_order_item.discount_1);
        netPriceField.html(data.purchase_order_item.net_price);
        return basePriceField.html(data.purchase_order_item.base_price);
      }
    };

    return $.ajax(ajaxConfig);
  });
});

var purchaseOrderIsBeingEdited = () => $(".blank_line_item_row .btn-stepper").length > 0;

